<template>
    <vx-navbar-action v-if="props.metadata.isImpersonator" nested href="/kiosk/impersonation/stop" :icon="faRotateLeft">
        Back To My Account
    </vx-navbar-action>

    <vx-navbar-action v-if="props.metadata.isPlatformAdmin" nested href="/kiosk" :icon="faMasksTheater">
        Kiosk
    </vx-navbar-action>
    <vx-navbar-action :icon="faGear" nested href="/settings" data-test="navbar-settings-action">
        Settings
    </vx-navbar-action>

    <vx-navbar-action
        v-if="props.metadata.showsTeamSwitcher"
        nested
        open
        :icon="faScreenUsers"
        data-test="navbar-teams-action"
    >
        Teams
        <template v-slot:items>
            <vx-navbar-action-item
                v-for="team in teams"
                :key="team.id"
                :href="switchTeamHref(team)"
                class="w-40 whitespace-normal!"
                nested
                data-test="navbar-team-switch-action"
            >
                <vx-radio v-if="!team.locked" class="mt-0.5" :modelValue="team.id == currentTeam.id"></vx-radio>
                <font-awesome-icon
                    v-else
                    :icon="faLock"
                    class="mt-0.5 text-slate-400"
                    data-test="navbar-team-locked"
                ></font-awesome-icon>
                {{ team.name }}
                <span v-if="team.locked" class="block text-xs text-slate-500"> Log In with SSO </span>
            </vx-navbar-action-item>
            <vx-navbar-action-item v-if="seeAllTeams" href="/settings#/teams" data-test="navbar-see-all-teams">
                See All Teams
            </vx-navbar-action-item>
        </template>
    </vx-navbar-action>

    <vx-button href="/logout" data-test="navbar-logout" color="muted-light" block class="mt-2">
        Logout <font-awesome-icon widthAuto class="text-sm" :icon="faRightFromBracket"></font-awesome-icon>
    </vx-button>
</template>

<script setup>
import { VxNavbarAction, VxNavbarActionItem, VxButton, VxRadio } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faRightFromBracket,
    faGear,
    faLock,
    faMasksTheater,
    faRotateLeft,
    faScreenUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { switchTeamHref } from '~/utils/team';

const props = defineProps({
    metadata: {
        type: Object,
        required: true,
    },
});

const seeAllTeams = Spark.state.teams?.length > 4;
const teams = Spark.state.teams?.slice?.(0, 4) || [];

const currentTeam = Spark.state.currentTeam;
</script>
